module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slidePic"
  }, [_c('van-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-index-banner1.png"),
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-index-banner1.png"),
      "alt": "",
      "srcset": ""
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f497810","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/SlidePics.vue
// module id = 1387
// module chunks = 0